module.exports = __webpack_public_path__ + "img/website-election-list.fd5a9404.png";